import { render, staticRenderFns } from "./StudentContentViews.vue?vue&type=template&id=2e08f224&scoped=true&"
import script from "./StudentContentViews.vue?vue&type=script&lang=js&"
export * from "./StudentContentViews.vue?vue&type=script&lang=js&"
import style0 from "./StudentContentViews.vue?vue&type=style&index=0&id=2e08f224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08f224",
  null
  
)

export default component.exports